fourToldApp.controller("creditListCntrl", function(xmppAuth, esb, userDomain, services, $routeParams, $sce, $location, $scope, $route, $controller, $rootScope, $cookieStore, $cookies, $localStorage, $mdDialog, $window, theme) {

    $scope.theme = theme.getTheme();
    /*$scope.theme =  JSON.parse($window.sessionStorage.getItem("theme"));
    if($scope.theme !== null){
        $scope.chatTheme = {header: {background: $scope.theme.statusbar_background_color}, footer: {background: $scope.theme.statusbar_background_color}, bars: {color: $scope.theme.statusbar_textcolor}, message_sent_background_color:{background: $scope.theme.message_sent_background_color}, sent_color:{'border-left': '15px solid' + $scope.theme.message_sent_background_color}, message_receive_background_color:{background: $scope.theme.message_receive_background_color}, receive_color:{'border-right': '15px solid' + $scope.theme.message_receive_background_color}, button_selection_chat:{background: $scope.theme.button_selection_chat_background_color, color: $scope.theme.button_selection_chat_textcolor},button_send:{
          background: $scope.theme.button_send_background_color,
          color: $scope.theme.button_send_textcolor,
          'box-shadow': '0 2px 5px 0 rgba(0, 0, 0, 0.26)'
        }};
      }*/

    $scope.currentTab = 0;
    $scope.changeTab = function (tabIndex) {
        $scope.currentTab = tabIndex;
        if(tabIndex == 1)  $scope.isRevolving = true;
    };
    $scope.isRevolving = $routeParams.type == "rot";
    $scope.allStatus = [{id:'ACTIVE', field: 'Activos'},{id:'PENDING', field: 'Pendientes'},{id:'COMPLETED', field: 'Históricos'}];
    $('#creditDetails').toggle('slide');
    $scope.getLoans = function() {
        $scope.progress = "ok";
        $scope.LENDER_IMG_URL = esb +"/security/lender/avatar/";
        $scope.references = [];
        services.loans('bearer ' + $window.localStorage.getItem('access_token1')).loans({}, function(response) {
            $scope.progress = undefined;
            if (response.data) {
                if (response.data[0] === undefined) {
                    $scope.dataExists = undefined;
                } else {
                    $scope.dataExists = "data";
                    $scope.loansData = response.data;
                    $scope.getActiveLoans();
                    $scope.getPendingLoans();
                    $scope.getCompleteLoans();
                    $scope.loans = $scope.activeLoans;
                    $scope.currentStatus = {id:'ACTIVE', field: 'Activos'};
                }
            }
        }, function(error) {
            $scope.showAlert("Ocurrio un error", "Pongase en contacto con soporte tecnico");
        });
    };

    $scope.getLenderImg = function(item) {
        return $scope.LENDER_IMG_URL + item.lender.entity.id;
    }

    $scope.showAlert = function(msg, title) {
        $scope.progress = undefined;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"))
    };

    $scope.checkEmpty = function(searchType, filterBy) {
        if (filterBy === "" && $scope.searchMade === true) {
            $scope.searchMade = false;
            $scope.search(searchType, filterBy)
        }
    };
    $scope.setLoansLocalProperties = function(l) {
        l.stringTotalAmount = 0;;
        l.loanDate = new Date(l.createDate);
        if(l.lenderProgramType == "REVOLVING_CREDIT" && l.fromLoanId > 0) {
             l.isRevolvingCredit = true;
        }
        if (!l.capitalAmount){ // avoid undefined/null data
            l.capitalAmount = 0;
        }
        //l.capitalAmount = l.capitalAmount;
        switch (l.status) {
            case "ACTIVE":
                l.locaStatus = "Activo";
                if (l.loanDetails && l.loanDetails.amortizationPlan != null) {
                    if (l.loanDetails.amortizationPlan.plan != null) {
                        l.localBalance = l.account.balance;
                        l.loanDetails.nextPayment = l.loanDetails.nextPayment ? l.loanDetails.nextPayment:0.0;
                        l.localLoanNext = l.loanDetails.nextPayment;
                    }
                    l.delay = l.loanDetails.totalDelayInterest > 0;
                    l.localLoanNextDate = l.loanDetails.nextPaymentDate ? new Date(l.loanDetails.nextPaymentDate) : "N/A";
                    l.localPaymentsDone = l.loanDetails.paymentsDone + " de " + l.duration;
               }
               break;
            case "DELAY":
            case "COMPLETED":
                l.locaStatus = "Histórico";
                break;
            case "DEBT_TRANSFER":
                l.locaStatus = "Deuda transferida a los codeudores/avales";
                break;
            case "REJECT":
            case "REFINANCED":
                l.locaStatus = "Activo";
                break;
            case "ACCEPTED":
                l.locaStatus = "Pendiente por recoger.";
                break;
            case "PROPOSED":
            case "ACCEPTED_TELLER_SELECTED":
                l.locaStatus = "Pendiente por recoger.";
                break;
            case "ACCEPTED_TELLER_RESERVED":
                l.locaStatus = "Pendiente por recoger.";
                break;
        }
        if(l.lender){
            if (l.lender.type == "COMMERCE") {
                l.financialEntity = "Comercio: " +  l.lender.entity.firstName;
            } else {
                l.financialEntity = "Entidad financiera: " +  l.lender.entity.firstName;
            }
        }

        if(l.totalAmount){
            l.stringTotalAmount = l.totalAmount;
        }
        return l;
    }

    $scope.getActiveLoans = function() {
        $scope.activeLoans = [];
        for (var i=0; i < $scope.loansData.length; i++) {
            l = $scope.loansData[i];
            l = $scope.setLoansLocalProperties(l);
            if(!$scope.isRevolving && !l.lenderProgramType.includes("PREPAID")) {
                if (l.status == "ACTIVE" || l.status == "DELAY" || l.status == "61") {
                    if ((l.lenderProgramType.includes("REVOLVING_CREDIT") && l.fromLoanId!= null) || !l.lenderProgramType.includes("REVOLVING_CREDIT"))
                        $scope.activeLoans.unshift(l);
                }
            }

            if($scope.isRevolving && l.fromLoanId == null) {
                if (l.status == "ACTIVE" || l.status == "DELAY" || l.status == "61"){
                    l.childLoans = $scope.getChildLoans(l.id);
                    $scope.activeLoans.unshift(l);
                }

            }
       }
    }

    $scope.getPendingLoans = function() {
        $scope.pendingLoans = [];
        for (var i=0; i < $scope.loansData.length; i++) {
            l = $scope.loansData[i];
            l = $scope.setLoansLocalProperties(l);
            l.stringTotalAmount = 0;
            if(l.totalAmount) {
                l.stringTotalAmount = l.totalAmount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                  });
            }

            if(!$scope.isRevolving && !l.lenderProgramType.includes("PREPAID")) {
                if (l.status == "PROPOSED" || l.status == "ACCEPTED" || l.status == "ACCEPTED_TELLER_SELECTED" || l.status == "ACCEPTED_TELLER_RESERVED") {

                    if ((l.lenderProgramType.includes("REVOLVING_CREDIT") && l.fromLoanId!= null) || !l.lenderProgramType.includes("REVOLVING_CREDIT"))
                        $scope.pendingLoans.unshift(l);
                }
            }

            if($scope.isRevolving && l.fromLoanId == null) {
                if (l.status == "PROPOSED" || l.status == "ACCEPTED" || l.status == "ACCEPTED_TELLER_SELECTED" || l.status == "ACCEPTED_TELLER_RESERVED") {
                    l.childLoans = $scope.getChildLoans(l.id);
                    $scope.pendingLoans.unshift(l);
                }
            }
        }
     }

     $scope.getCompleteLoans = function() {
        $scope.completeLoans = [];
        for (var i=0; i < $scope.loansData.length; i++) {
            l = $scope.loansData[i];
            l = $scope.setLoansLocalProperties(l);
            l.stringTotalAmount = 0;

            if(l.totalAmount){
                l.stringTotalAmount = l.totalAmount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                  });
            }

            if(!$scope.isRevolving && !l.lenderProgramType.includes("PREPAID")) {
                if (l.status == "COMPLETED" || l.status == "REJECTED" || l.status == "00" || l.status == "REFINANCED" || l.status == "DEBT_TRANSFER" || l.status == "CANCELLED") {
                    if ((l.lenderProgramType.includes("REVOLVING_CREDIT") && l.fromLoanId!= null) || !l.lenderProgramType.includes("REVOLVING_CREDIT"))
                        $scope.completeLoans.unshift(l);
                 }
             }

             if($scope.isRevolving && l.fromLoanId == null) {
                if (l.status == "COMPLETED" || l.status == "REJECTED" || l.status == "00" || l.status == "REFINANCED" || l.status == "DEBT_TRANSFER" || l.status == "CANCELLED"){
                    l.childLoans = $scope.getChildLoans(l.id);
                    $scope.completeLoans.unshift(l);
                }
            }
        }

     }

     $scope.showDetails = function(loan) {
        $scope.progress="ok";
        if($scope.isRevolving) {
            $window.sessionStorage.setItem("viewTemplate", "loanList");
        }
        else {
            $window.sessionStorage.setItem("viewTemplate", "loanList");
        }

        $scope.guarantorList = [];
        var periodicity = loan.periodicity;
        switch(loan.periodicity) {               
            case 'DAILY':  
                periodicity = 'Diario'; break;
            case 'WEEKLY': 
                periodicity = 'Semanal'; break;
            case 'BIWEEKLY': 
                periodicity = 'Quincenal'; break;
            case 'MONTHLY':  
                periodicity = 'Mensual'; break;
            case 'TWO_MONTHLY': 
                periodicity = 'Bimestral'; break;
            case 'THREE_MONTHLY': 
                periodicity = 'Trimestral'; break;
            case 'SIX_MONTHLY': 
                periodicity = 'Semestral'; break;
            case 'ANNUAL': 
                periodicity = 'Anual'; break;
            case 'ONE_PAYMENT': 
                periodicity = 'Cuota única'; break;    
        }
        $window.sessionStorage.setItem("loanDetails",  JSON.stringify(loan.loanDetails));
        $window.sessionStorage.setItem("account",  JSON.stringify(loan.account));
        $window.sessionStorage.setItem("loanFees",  JSON.stringify(loan.loanFees));
        loanLocalData = {};
        loanLocalData.duration = loan.duration;
        loanLocalData.id = loan.id;
        loanLocalData.createDate = loan.createDate;
        loanLocalData.interestAmount = loan.interestAmount;
        loanLocalData.interest = loan.interest;
        loanLocalData.periodInterest = loan.periodInterest;
        loanLocalData.periodicity = periodicity;
        loanLocalData.delayInterest = loan.delayInterest;
        loanLocalData.prefixCurrency = loan.prefixCurrency;
        loanLocalData.suffixCurrency = loan.suffixCurrency;
        $window.sessionStorage.setItem("loanLocalData",  JSON.stringify(loanLocalData));
         $scope.guarantorList1 = services.guarantors2('bearer '+$window.localStorage.getItem('access_token1'), loan.id).getGuarantorLoanProposals({}, {}, function(response){
             if(response.code === 1 && response.data[0]){
                 $scope.userSelfieGuarantor = esb+"/security/"+response.data[0].guarantor.userSelfie;
                 response.data.forEach(function(item){
                     //item.status = $scope.get_loan_status(item.loan.status);
                     item.guarantorName = item.guarantor.entity.firstName + " "  + item.guarantor.entity.lastName;
                     item.phoneNumber = item.guarantor.userName;
                     item.guaranteedAmount = item.proposalRequest.guaranteedAmount;

                     $scope.guarantorList.push(item);
                     //item.status = "Finalizado";
                     switch (item.proposalRequest.status) {
                         case "ACCEPTED":
                             item.status = "Aceptado";
                             break;
                         case "REJECTED":
                             item.status = "Rechazado";
                             break;
                         case "EXPIRED":
                             item.status = "Expirado";
                             break;
                     }
                 });
             }
             console.log($scope.guarantorList);
             $window.sessionStorage.setItem("loanGuarantors",  JSON.stringify($scope.guarantorList));
             $location.path("/loanDetails");
         });
    };

    $scope.getChildLoans = function(loanId) {
        var childLoans = [];
        switch ($scope.currentStatus.id) {
            case "ACTIVE":
                var loans = $scope.loansData;
                for(loan of loans) {
                    if(loan.fromLoanId == loanId) {
                        childLoans.unshift(loan);
                    }
                }
            break;
            case "PENDING":
                var loans = $scope.loansData;
                for(loan of loans) {
                    if(loan.fromLoanId == loanId) {
                        childLoans.unshift(loan);
                    }
                }
            break;
            case "COMPLETED":
                var loans = $scope.loansData;
                for(loan of loans) {
                    if(loan.fromLoanId == loanId) {
                        childLoans.unshift(loan);
                    }
                }
            break;
          }
          return childLoans;
    }


    $scope.changeStatus = function(statusSelected) {
        $scope.currentStatus = statusSelected;
        switch (statusSelected.id) {
            case "ACTIVE":
                $scope.loans = $scope.activeLoans;
                $scope.showChevron = true;
                $scope.showMore = true;
              break;
            case "PENDING":
                $scope.loans = $scope.pendingLoans;
                $scope.showChevron = false;
                $scope.showMore = true;
              break;
            case "COMPLETED":
                $scope.loans = $scope.completeLoans;
                $scope.showChevron = false;
                $scope.showMore = true;
              break;
          }
    };
    $scope.toggleCreditDetails = function(index) {
        $('#creditDetails' + index).toggle('slide');
    }

});
